import React from "react";

interface ProductImageDisclaimerProps {
  isImageSelected: boolean;
  productImageDisclaimer?: string;
}

const ProductImageDisclaimer = ({
  isImageSelected,
  productImageDisclaimer,
}: ProductImageDisclaimerProps) => {
  return isImageSelected && productImageDisclaimer ? (
    <div
      className="bg-white text-sm leading-3 my-3 text-center"
      data-testid="productImageDisclaimer"
      // TODO: remove dangerouslySetInnerHTML

      dangerouslySetInnerHTML={{
        __html: `Note: ${productImageDisclaimer}`,
      }}
    />
  ) : (
    <></>
  );
};

export default ProductImageDisclaimer;
